import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_pharmacy/supply-forecast")({
  beforeLoad: ({ context }) => guardRoute(context.me, "supply-forecast"),
  component: Outlet,
});
